import React, {
  useState,
  useEffect,
}                           from 'react';
import PropTypes            from 'prop-types';
import { useTranslation }   from 'react-i18next';
import Modal                from '@material-ui/core/Modal';
import QuestionAnswerIcon   from '@material-ui/icons/QuestionAnswer';

import Button               from '~/components/Button';
import Paper                from '~/components/Paper';
import IconButton           from '@material-ui/core/IconButton';
import Icon                 from '@material-ui/core/Icon';
import Request              from '~/providers/Request';
import MenuItem             from '@material-ui/core/MenuItem';
import useStyles            from './styles';
import { Typography }       from '@material-ui/core';
import Grid                 from '@material-ui/core/Grid';
import TextField            from '@material-ui/core/TextField';
import { toast }            from 'react-toastify';

function ModalFolder(props) {

  const { modal, onClose, categories, isEdit, folder } = props;
  const { t } = useTranslation();
  const trAttr = (attr) => t(`faq.attributes.${attr}`);
  const initialState = {
    id: '',
    name: '',
    sorter: 0,
    category: '',
  };
  const [values, setValues] = useState(initialState);

  useEffect(() => {
    setValues({
      id: folder.id ? folder.id : '',
      name: folder.name ? folder.name : '',
      sorter: folder.sorter ? folder.sorter : 0,
      category: folder.category ? folder.category : '',
    });
  }, [folder]);

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };

  const classes = useStyles();

  async function saveAction() {
    const data = {
      attributes: {
        name: values.name,
        sorter: values.sorter,
        faq_category_id: values.category,
      }
    };

		if (!isEdit) {
			try {
        await Request.post('/admin/faq/folders', { data }, {}, { controller: 'faq' });
        setValues(initialState);
				onClose();
				toast.success(t('faq.extras.save_folder'));
			} catch (e) {
				console.log(e);
			}
		} else {
			try {
        await Request.put(`/admin/faq/folders/${values.id}`, { data }, {}, { controller: 'faq' });
        setValues(initialState);
				onClose();
				toast.success(t('faq.extras.edit_folder'));
			} catch (e) {
				console.log(e);
			}
		}
  }
  return (
    <Modal
      open={modal}
      onClose={onClose}
    >
      <div className={classes.root} >
        <Paper
          classes={{
            root: classes.paper
          }}
          Icon={QuestionAnswerIcon}
          iconColor="blue"
          title={isEdit? folder.name : t('faq.extras.folder_new')}
          actions={
            <IconButton
              onClick={onClose}
            >
              <Icon>clear</Icon>
            </IconButton>
          }
        >
          <Grid style={{marginTop: 15}} container spacing={2}>
            <Grid item xs={2} md={2}>
              <Typography align='left' variant='subtitle1' >{trAttr('name')}</Typography>
            </Grid>
            <Grid item xs={12} md={10}>
            <TextField
              id="name"
              name="name"
              fullWidth
              value={values.name}
              onChange={handleChange('name')}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
            </Grid>

          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={2} md={2}>
            <Typography align='left' variant='subtitle1' >{trAttr('sorter')}</Typography>
            </Grid>
            <Grid item xs={12} md={10}>
            <TextField
              id="sorter"
              fullWidth
              value={values.sorter}
              onChange={handleChange('sorter')}
              InputLabelProps={{
                shrink: true,
              }}
              name="sorter"
              variant="outlined"
            />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={2} md={2}>
            <Typography align='left' variant='subtitle1' >{trAttr('category')}</Typography>
            </Grid>
            <Grid item xs={12} md={8}>
            <TextField
              id="category"
              select
              fullWidth
              value={values.category}
              onChange={handleChange('category')}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              variant="outlined"
            >
              {categories && categories.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            </Grid>
            </Grid>
          <div style={{ marginTop: 40, textAlign: 'right', borderColor: 'black' }}>
          <hr/>
            <Button variant='contained' color='grey' onClick={onClose} className={classes.button}>
              {t('form-cancel')}
            </Button>
            <Button variant="contained" color='success' onClick={() => { saveAction(); }} className={classes.button}>
              {t('form-submit')}
            </Button>
          </div>
        </Paper>
      </div>
    </Modal>
  );
}

ModalFolder.propTypes = {
  modal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  folder: PropTypes.object.isRequired,
};
export default ModalFolder;
